import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "N2JjMTE3NzM4YjIxYzk4YmVkN2U5ODUzOWU5ZDA4M2E=",
  "Tenant-Access-Key": "vi2FcycDJypuYQ",
};

export const api = axios.create({
  baseURL: "https://immersive-game-india.confirmu.com",
  headers,
});

export const BASE_URL = "https://immersive-game-india.confirmu.com";
